import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import { state, mutations, getters } from './mutations'
import actions from './actions'

// 引入子模块
import draw from './modules/draw.js'
import drawMap from './modules/drawMap.js'
import meteorologicalMap from './modules/meteorologicalMap'
import homeMap from './modules/homeMap'
import switchMap from './modules/switchMap'
import station_plan from './modules/station_plan'
import planrele from './modules/planrele'
import station_alarm from './modules/station_alarm'
import swichLayer from './modules/swichLayer'
import station_task from './modules/station_task'
import rightCon from './modules/rightCon'

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: { //存放子模块
        homeMap,
        draw,
        drawMap,
        meteorologicalMap,
        switchMap,
        station_plan,
        planrele,
        station_alarm,
        swichLayer,
        station_task,
        rightCon
    }
});